<main class="auth-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'auth.common.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="auth-head">
    <div class="auth-head__kicker">
      <span>{{ 'auth.register.kicker' | translate }}</span>
      <span class="auth-head__dot">·</span>
      <span>{{ 'auth.register.kickerTime' | translate }}</span>
    </div>
    <h1 class="auth-head__title">
      {{ 'auth.register.titleMain' | translate }}
      <span class="auth-head__accent">{{ 'auth.register.titleAccent' | translate }}</span>
    </h1>
  </div>

  <auth-google-sign-in-button
    [label]="'auth.register.googleCta' | translate"
    [loading]="loading()"
    (clicked)="onGoogleClick()" />

  @if (showAppleSignIn) {
    <auth-apple-sign-in-button
      [label]="'auth.register.appleCta' | translate"
      [loading]="loading()"
      (clicked)="onAppleClick()" />
  }

  <auth-divider [label]="'auth.common.or' | translate" />

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="field-row">
      <div class="field field--half">
        <div class="field__row">
          <span class="field__label">{{ 'auth.register.fieldFirstName' | translate }}</span>
        </div>
        <sz-text-input
          type="text"
          autocomplete="given-name"
          [placeholder]="'auth.register.firstNamePlaceholder' | translate"
          prefixIcon="user"
          formControlName="firstName"
          [errorText]="firstNameError()" />
      </div>
      <div class="field field--half">
        <div class="field__row">
          <span class="field__label">{{ 'auth.register.fieldLastName' | translate }}</span>
        </div>
        <sz-text-input
          type="text"
          autocomplete="family-name"
          [placeholder]="'auth.register.lastNamePlaceholder' | translate"
          formControlName="lastName"
          [errorText]="lastNameError()" />
      </div>
    </div>

    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'auth.common.fieldEmail' | translate }}</span>
      </div>
      <sz-text-input
        type="email"
        autocomplete="email"
        [placeholder]="'auth.common.emailPlaceholder' | translate"
        prefixIcon="mail"
        formControlName="email"
        [errorText]="emailError()" />
    </div>

    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'auth.common.fieldPassword' | translate }}</span>
      </div>
      <sz-password-input
        autocomplete="new-password"
        [placeholder]="'auth.common.passwordPlaceholder' | translate"
        formControlName="password"
        [errorText]="passwordError()"
        [helperText]="passwordError() ? null : ('auth.register.passwordHelper' | translate)" />
      @if (passwordValue().length > 0) {
        <sz-password-strength-meter [strength]="passwordStrength()" />
      }
    </div>

    <label class="check" [class.check--on]="form.controls.terms.value">
      <input type="checkbox" class="check__input" formControlName="terms" />
      <span class="check__box" aria-hidden="true">
        @if (form.controls.terms.value) {
          <sz-icon name="check" [size]="12" />
        }
      </span>
      <span class="check__text">
        {{ 'auth.register.termsPrefix' | translate }}
        <a [routerLink]="termsPath">{{ 'auth.common.termsLink' | translate }}</a>
        {{ 'auth.common.and' | translate }}
        <a [routerLink]="privacyPath">{{ 'auth.common.privacyLink' | translate }}</a
        >.
      </span>
    </label>

    @if (errorMessage(); as msg) {
      <p class="auth-error" role="alert">{{ msg }}</p>
    }

    <button
      type="submit"
      class="cta cta--primary"
      [disabled]="loading() || form.invalid"
      [attr.aria-busy]="loading() ? 'true' : null">
      @if (loading()) {
        <span class="spinner" role="status" [attr.aria-label]="'auth.register.submitAria' | translate"></span>
      } @else {
        <span>{{ 'auth.register.submitCta' | translate }}</span>
        <sz-icon name="arrow-right" [size]="16" />
      }
    </button>
  </form>

  <p class="alt">
    {{ 'auth.register.altPrefix' | translate }}
    <a [routerLink]="loginPath">{{ 'auth.register.altLink' | translate }}</a>
  </p>
</main>
